import React from 'react';
import { useNavigate } from 'react-router-dom';
function PageNotFound() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="page-not-found">
      <div className="page-not-found-content">
        <div className="error-code">404</div>
        <h1>Page Not Found</h1>
        <p>
          Sorry, we couldn't find the page you're looking for. 
          The page may have been moved, deleted, or you may have entered an incorrect URL.
        </p>
        
        <div className="page-not-found-actions">
          <button onClick={handleGoHome} className="btn btn-primary">
            Go Home
          </button>
          <button onClick={handleGoBack} className="btn btn-secondary">
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}

export default PageNotFound;
